/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CarpsaleHistoryManagementListOrderRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: CarpsaleHistoryManagementListOrderRequest.direction | null;
    status?: Array<string>;
    code?: string | null;
    name?: string | null;
    startDate?: string | null;
    endDate?: string | null;
};

export namespace CarpsaleHistoryManagementListOrderRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

